import { NEWS_PANEL_CREATE } from 'client/redux/news/constants';
import { reduceByTypes } from 'client/redux/apiHelpers';

const defaultState = {
  isCreating: false,
  error: null,
};

export default function newPanelReducer (state = defaultState, action) {
  state = reduceByTypes(NEWS_PANEL_CREATE, state, action, {requestProp: 'isCreating', successSpread: true, successPickProps: ['newsItem']});
  return state;
}
